<template>
  <div class="hot-column-list">
    <a
      href="javascript:;"
      class="hot-column-sku"
      v-for="(sku, index) in skuList"
      :key="index"
      @click="dealWith(sku.item_id, sku.sku_id, sku.platform, sku.item_type)"
      >
      <div class="sku-img">
        <img v-lazy="sku.pic_url" alt />
      </div>
      <div class="sku-name">
        {{sku.name}}
      </div>
    </a>
  </div>
</template>

<script>
import api from '../../utils/api'
let flag = false
export default {
  name: 'hotColumns',
  props: {
    skuList: {}
  },
  methods: {
    async dealWith (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.hot-column-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .hot-column-sku {
    .flex-column-center;
    margin-bottom: 0.33rem;
    &:nth-child(3n-1) {
      margin: 0 0.33rem 0.33rem;
    }
    .sku-img {
      width: 2.08rem;
      height: 1rem;
    }
    .sku-name {
      width: 2.08rem;
      .ellipsis2;
      padding-top: 0.32rem;
      font-size: @fz24;
      color: @base;
    }
  }
}
</style>
